import { Flex } from '@chakra-ui/react';
import { AltTextMenu } from 'modules/Editor/components/Toolbar/AltTextMenu/AltTextMenu';
import { ToolbarDivider } from 'modules/common/components/Toolbar/ToolbarDivider';
import { ReactElement, useMemo } from 'react';
import { useWidget } from 'widgets/sdk';
import { InteractiveMenu } from 'widgets/sdk/Toolbar/InteractiveMenu';

import { LineToolbarOptions, LineWidgetToolbarContent } from '../../common/toolbar/CommonLineToolbarContent';
import { LineWidgetData, Side } from '../LineWidget.types';

export const LineWidgetToolbarMenu = (): ReactElement => {
  const {
    type,
    strokeColor,
    startPort,
    endPort,
    strokeWidth,
    strokeDashType,
    startArrowStyle,
    endArrowStyle,
    updateWidget,
    widgetId,
  } = useWidget<LineWidgetData>();

  // If line is connected to center port, disable line type and arrow options
  const disabledOptions = useMemo(() => {
    let options: LineToolbarOptions[] = [];
    if (startPort?.side === Side.CENTER || endPort?.side === Side.CENTER) {
      options.push(LineToolbarOptions.lineType);

      if (startPort?.side === Side.CENTER) {
        options.push(LineToolbarOptions.startArrow);
      }
      if (endPort?.side === Side.CENTER) {
        options.push(LineToolbarOptions.endArrow);
      }
    }
    return options;
  }, [startPort, endPort]);

  return (
    <Flex mr='8px' gap='8px' align='center'>
      <LineWidgetToolbarContent
        values={{
          strokeColor,
          strokeWidth,
          strokeDashType,
          startArrowStyle,
          endArrowStyle,
          type,
        }}
        onUpdate={updateWidget}
        disabledOptions={disabledOptions}
      />
      <ToolbarDivider />

      <AltTextMenu widgetId={widgetId} />

      <InteractiveMenu />
    </Flex>
  );
};
